import React, { Component } from "react";

import "./TimelineItemContainer.scss"

class TimelineItemContainer extends Component {
  constructor() {
    super();
    this.state = {
      //  currItem: []
    }
  }
  /*
  componentDidMount() {
    this.setState({
      currItem: this.props.item
    })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      currItem: nextProps.item
    })
  }
  */
  render() {
    const itemImage = {
      backgroundImage: `url(./static/images/desktop/timeline/${this.props.item.image}`
    }
    /*

      <article style={{ display: (this.props.currItem == this.props.index ? "block" : (this.props.currItem == null ? (this.props.index == 0 ? "block" : "none") : "none")) }}>
      */
    return (
      <article className={(this.props.currItem == this.props.index ? "active" : (this.props.currItem == null ? (this.props.index == 0 ? "active" : "") : ""))}>
        <div className="padding">
          <div className="container">
            <div className="imagehead" style={itemImage}></div>
            <div className="separator"></div>
            <div className="article-item">
              <div className="alternate">
                <div className="head">
                  <h3>
                    {this.props.item.teaser}
                  </h3>
                  {
                    /*

                  <h4>
                    {this.props.item.teaser}
                  </h4>
                  */
                  }
                </div>
                <div className="text" dangerouslySetInnerHTML={{ __html: this.props.item.desc }}></div>
              </div>
              <div className="separator"></div>
              <div className="image" style={itemImage}></div>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default TimelineItemContainer;



// WEBPACK FOOTER //
// ./src/Components/Timeline/TimelineItemContainer.js